import { Action } from '@ngrx/store';
import { IChatConfiguration, IDeviceModel, IMCConnectionInfo } from '@nx-fe/services';
import { SabhaCustomPresenceStatus, SabhaRoomType } from '@soti/sabha-components';
import { SabhaPresenceStatus } from '@soti/sabha-components/lib/presence/presence-status';
import { Observable } from 'rxjs';
import { SabhaUserPreference } from '../models/sabha-user-preference';
import {
  DeviceChatDialogPosition,
  DeviceChatDialogSize,
  DeviceChatDialogView,
  ErrorViewType,
  PendingRoomConfiguration,
  SabhaInitState,
} from './reducers';

export enum SabhaActionTypes {
  HTTP_ERROR = '[SABHA] HTTP REQUEST ERROR',
  PARTICIPANT_IN_SESSION_ERROR = '[SABHA] PARTICIPANT ALREADY IN SESSION ERROR',
  PERMISSION_ERROR_NOTIFICATION = '[SABHA] NOTIFICATION PARTICIPANT DOES NOT HAVE ENOUGH PERMISSION',
  DEVICE_ERROR = '[SABHA] DEVICE ERROR',
  CALL_TIMEOUT_ERROR = '[SABHA] CALL TIMEOUT',
  INIT = '[SABHA] INIT',
  SIGN_OUT = '[SABHA] SIGN OUT',
  DISABLE_ONBOARDING = '[SABHA] DISABLE ONBOARDING',
  LOAD_ONBOARDING_SETTINGS = '[SABHA] LOAD ONBOARDING SETTINGS',
  LOAD_ONBOARDING_SETTINGS_SUCCESS = '[SABHA] LOAD ONBOARDING SETTINGS SUCCESS',
  OPEN_ONBOARDING_SUCCESS = '[SABHA] OPEN ONBOARDING SUCCESS',
  USER_LOAD_SUCCESS = '[SABHA] USER LOAD SUCCESS',
  SELECT_ROOM = '[SABHA] SELECT SABHA ROOM',
  SHOW_CHAT_NOTIFICATION = '[SABHA] SHOW CHAT NOTIFICATION',
  SHOW_CHAT_NOTIFICATION_SUCCESS = '[SABHA] SHOW CHAT NOTIFICATION SUCCESS',
  HIDE_CHAT_NOTIFICATION = '[SABHA] HIDE CHAT NOTIFICATION',
  PENDING_SELECT_ROOM = '[SABHA] SELECT PENDING SABHA ROOM',
  SET_ROOM_START_TYPE = '[SABHA] SET ROOM START TYPE',
  REMOVE_PENDING_SELECT_ROOM = '[SABHA] REMOVE PENDING SABHA ROOM',
  SELECT_CURRENT_VIEW = '[SABHA] SELECT CURRENT VIEW',
  LOCAL_PRESENCE_STATUS_CHANGE = '[SABHA] LOCAL PRESENCE STATUS CHANGE',
  LOCAL_PRESENCE_STATUS_CHANGED = '[SABHA] LOCAL PRESENCE STATUS CHANGED',
  START_DEVICE_CHAT = '[SABHA] START DEVICE CHAT',
  START_DEVICE_CHAT_SUCCESS = '[SABHA] START DEVICE CHAT SUCCESS',
  START_DEVICE_CHAT_FAILED = '[SABHA] START DEVICE CHAT FAILED',
  VALIDATE_DEVICE_SUPPORT_BEFORE_CALL_RING = '[SABHA] VALIDATE DEVICE SUPPORT BEFORE CALL RING',
  START_ROOM_CALL = '[SABHA] START ROOM CALL',
  RINGING_CALL = '[SABHA] RINGING CALL',
  CLEANUP_RINGING_CALL = '[SABHA] CLEANUP RINGING CALL',
  EXISTING_CALL_PROMPT = '[SABHA] EXISTING CALL PROMPT',
  UPDATE_CALL_LOCAL_MEDIA = '[SABHA] UPDATE CALL LOCAL MEDIA',
  HOLD_ROOM_CALL = '[SABHA] HOLD ROOM CALL',
  RESUME_ROOM_CALL = '[SABHA] RESUME ROOM CALL',
  HANGUP_ROOM_CALL = '[SABHA] HANGUP ROOM CALL',
  HANGUP_CALL_SUCCESS = '[SABHA] HANGUP ROOM CALL SUCCESS',
  HANGUP_CALL_FAILED = '[SABHA] HANGUP ROOM CALL FAILED',
  START_ROOM_CALL_SUCCESS = '[SABHA] START ROOM CALL SUCCESS',
  START_ROOM_CALL_FAILED = '[SABHA] START ROOM CALL FAILED',
  REMOVE_ROOM = '[SABHA] REMOVE ROOM',
  REMOVE_ROOM_SUCCESS = '[SABHA] REMOVE ROOM SUCCESS',
  REMOVE_ROOM_FAILED = '[SABHA] REMOVE ROOM FAIELD',
  START_RC = '[SABHA] START RC',
  START_RC_SUCCESS = '[SABHA] START RC SUCCESS',
  NAVIGATE_TO_INCIDENT = '[SABHA] NAVIGATE TO INCIDENT',
  RC_STARTED = '[SABHA] RC STARTED',
  RC_ENDED = '[SABHA] RC ENDED',
  SET_MINIFIED_VIEW_DEVICE = '[SABHA] SET MINIFIED VIEW DEVICE',
  REMOVE_MINIFIED_VIEW_DEVICE = '[SABHA] REMOVE MINIFIED VIEW DEVICE',
  OPEN_CHAT_WINDOW = '[SABHA] OPEN CHAT WINDOW',
  SHOW_CHAT_ERROR_VIEW = '[SABHA] SHOW CHAT ERROR VIEW',
  SHOW_CHAT_PERMISSION_ERROR_VIEW = '[SABHA] SHOW PERMISSION CHAT ERROR VIEW',
  RESIZE_CHAT_WINDOW = '[SABHA] RESIZE CHAT WINDOW',
  SET_CHAT_WINDOW_SIZE_ON_HIDE = '[SABHA] SET CHAT WINDOW SIZE ON HIDE',
  IS_SABHA_ALLOWED = '[SABHA] ALLOW SABHA USAGE',
  TOGGLE_CHAT = '[SABHA] TOGGLE CHAT BUTTON',
  CHAT_CONFIG_LOAD_SUCCESS = '[SABHA] CHAT CONFIG LOAD SUCCESS',
  UPDATE_CHAT_WINDOW_POSITION = '[SABHA] UPDATE CHAT WINDOW POSITION',
  UPDATE_ACTIVE_CALL_ROOM = '[SABHA] UPDATE ACTIVE CALL ROOM',
  ADD_INACTIVE_ROOM = '[SABHA] ADD INACTIVE ROOM',
  REMOVE_INACTIVE_ROOM = '[SABHA] REMOVE INACTIVE ROOM',
  UPDATE_ROOM_ACTIVITY = '[SABHA] UPDATE ROOM ACITIVTY',
  UPDATE_SABHA_USER_PREFERENCE = '[SABHA] UPDATE SABHA USER PREFERENCE',
  UPDATE_SABHA_USER_PREFERENCE_SUCCESS = '[SABHA] UPDATE SABHA USER PREFERENCE SUCCESS',
  SET_SABHA_USER_PREFERENCE = '[SABHA] SET SABHA USER PREFERENCE SUCCESS',
  SET_DEVICE_SEARCH_TEXT = '[SABHA] SET SABHA DEVICE SEARCH TEXT',
  MC_CONNECTIONS_LOAD_SUCCESS = '[SABHA] MC CONNECTIONS LOAD SUCCESS',
  SABHA_INIT_STATE_CHANGED = '[SABHA] INIT STATE CHANGED',
  START_CHAT_ROOM_LOADING = '[SABHA] LOADING START CHAT ROOM',
  DOWNLOAD_CHAT_TRANSCRIPT = '[SABHA] DOWNLOAD CHAT TRANSCRIPT',
  SEND_CHAT_MESSAGE = '[SABHA] SEND CHAT MESSAGE',
  CLEAR_ROOM_NOTIFICATIONS = '[SABHA] CLEAR ROOM NOTIFICATIONS',
  ADD_DIALOG = '[SABHA] ADD DIALOG',
  REMOVE_DIALOG = '[SABHA] REMOVE DIALOG',
  CLOSE_DIALOG = '[SABHA] CLOSE DIALOG',
  CLOSE_ALL_DIALOGS = '[SABHA] CLOSE ALL DIALOGS',
  CLOSE_ALL_DIALOGS_SUCCESS = '[SABHA] CLOSE ALL DIALOGS SUCCESS',
  OPEN_DIALOG_SUCCESS = '[SABHA] OPEN DIALOG SUCCESS',
}

export class HttpErrorAction implements Action {
  readonly type = SabhaActionTypes.HTTP_ERROR;
  constructor(public error: any) {}
}

export class SabhaParticipantExistsErrorAction implements Action {
  readonly type = SabhaActionTypes.PARTICIPANT_IN_SESSION_ERROR;
  constructor(
    public deviceId: string,
    public participantId: string,
    public deviceName: string,
    public technicianDisplayName: string
  ) {}
}

export class SabhaRoomLoadingAction implements Action {
  readonly type = SabhaActionTypes.START_CHAT_ROOM_LOADING;
  constructor(public isLoading: boolean) {}
}

export class SabhaInitStateChangedAction implements Action {
  readonly type = SabhaActionTypes.SABHA_INIT_STATE_CHANGED;
  constructor(public sabhaInitState: SabhaInitState) {}
}

export class SabhaDeviceErrorAction implements Action {
  readonly type = SabhaActionTypes.DEVICE_ERROR;
  constructor() {}
}

export class SabhaCallTimeoutAction implements Action {
  readonly type = SabhaActionTypes.CALL_TIMEOUT_ERROR;
  constructor(public deviceId: string) {}
}

export class InitAction implements Action {
  readonly type = SabhaActionTypes.INIT;
  constructor() {}
}

export class ToggleChatAction implements Action {
  readonly type = SabhaActionTypes.TOGGLE_CHAT;
  constructor(public chatToggle: boolean, public size?: DeviceChatDialogSize) {}
}

export class ShowPermissionErrorNotificationAction implements Action {
  readonly type = SabhaActionTypes.PERMISSION_ERROR_NOTIFICATION;
  constructor(public permission: string, public deviceId: string) {}
}

export class SetSabhaAllowedAction implements Action {
  readonly type = SabhaActionTypes.IS_SABHA_ALLOWED;
  constructor(public isAllowed: boolean) {}
}

export class SignOutAction implements Action {
  readonly type = SabhaActionTypes.SIGN_OUT;
  constructor() {}
}

export class LoadOnboardingSettingsAction implements Action {
  readonly type = SabhaActionTypes.LOAD_ONBOARDING_SETTINGS;
  constructor() {}
}

export class LoadOnboardingSettingsSuccessAction implements Action {
  readonly type = SabhaActionTypes.LOAD_ONBOARDING_SETTINGS_SUCCESS;
  constructor(public showOnboarding: boolean) {}
}

export class OpenOnboardingSuccessAction implements Action {
  readonly type = SabhaActionTypes.OPEN_ONBOARDING_SUCCESS;
  constructor(public dialogId: string, public afterClosed$: () => Observable<any>) {}
}

export class DisableOnboardingAction implements Action {
  readonly type = SabhaActionTypes.DISABLE_ONBOARDING;
  constructor() {}
}

export class SabhaUserLoadSuccessAction implements Action {
  readonly type = SabhaActionTypes.USER_LOAD_SUCCESS;
  constructor(public sabhaUserId: string) {}
}

export class SelectRoomAction implements Action {
  readonly type = SabhaActionTypes.SELECT_ROOM;
  constructor(
    public roomId: string,
    public startType: SabhaRoomType = SabhaRoomType.Chat,
    public changeView: boolean = true
  ) {}
}

export class SabhaLocalPresenceStatusChangedAction implements Action {
  readonly type = SabhaActionTypes.LOCAL_PRESENCE_STATUS_CHANGED;
  constructor(public status: SabhaPresenceStatus) {}
}

export class SabhaLocalPresenceStatusChangeAction implements Action {
  readonly type = SabhaActionTypes.LOCAL_PRESENCE_STATUS_CHANGE;
  constructor(public status: SabhaCustomPresenceStatus) {}
}

export class StartDeviceChatAction implements Action {
  readonly type = SabhaActionTypes.START_DEVICE_CHAT;
  constructor(
    public rcDeviceId: string,
    public roomName: string,
    public startType: SabhaRoomType = SabhaRoomType.Chat
  ) {}
}
export class ShowChatNotificationAction implements Action {
  readonly type = SabhaActionTypes.SHOW_CHAT_NOTIFICATION;
  constructor(public xSightRoomId: string, public messageId: string, public roomName: string, public message: string) {}
}

export class ShowChatNotificationSuccessAction implements Action {
  readonly type = SabhaActionTypes.SHOW_CHAT_NOTIFICATION_SUCCESS;
  constructor(public xSightRoomId: string) {}
}

export class HideChatNotificationAction implements Action {
  readonly type = SabhaActionTypes.HIDE_CHAT_NOTIFICATION;
  constructor(public roomId: string) {}
}

export class StartDeviceChatSuccessAction implements Action {
  readonly type = SabhaActionTypes.START_DEVICE_CHAT_SUCCESS;
  constructor(public roomId: string) {}
}

export class AddPendingActiveChatAction implements Action {
  readonly type = SabhaActionTypes.PENDING_SELECT_ROOM;
  constructor(public pendingActiveRoom: PendingRoomConfiguration) {}
}

export class RemovePendingActiveChatAction implements Action {
  readonly type = SabhaActionTypes.REMOVE_PENDING_SELECT_ROOM;
  constructor() {}
}

export class SetRoomStartTypeAction implements Action {
  readonly type = SabhaActionTypes.SET_ROOM_START_TYPE;
  constructor(public startType?: SabhaRoomType) {}
}

export class StartDeviceChatFailedAction implements Action {
  readonly type = SabhaActionTypes.START_DEVICE_CHAT_FAILED;
  constructor(public error: any) {}
}

export class StartRoomCallAction implements Action {
  readonly type = SabhaActionTypes.START_ROOM_CALL;
  constructor(public roomId: string, public isVideoCall: boolean = true, public changeView: boolean = true, public isSilentInvite?: boolean) {}
}

export class RingingCallAction implements Action {
  readonly type = SabhaActionTypes.RINGING_CALL;
  constructor(public roomId: string, public isVideoAllowed: boolean, public deviceId: string, public isSilentInvite?: boolean) {}
}

export class ValidateSupportBeforeCallRingAction implements Action {
  readonly type = SabhaActionTypes.VALIDATE_DEVICE_SUPPORT_BEFORE_CALL_RING;
  constructor(public roomId: string, public isVideoAllowed: boolean, public changeView: boolean = true, public isSilentInvite?: boolean) {}
}

export class CleanupRingingCallAction implements Action {
  readonly type = SabhaActionTypes.CLEANUP_RINGING_CALL;
  constructor(public roomId: string) {}
}

export class ShowExistingCallPromptAction implements Action {
  readonly type = SabhaActionTypes.EXISTING_CALL_PROMPT;
  constructor(public roomId: string, public callId: string, public isVideoAllowed: boolean, public deviceId: string) {}
}

export class HoldCallAction implements Action {
  readonly type = SabhaActionTypes.HOLD_ROOM_CALL;
  constructor(public roomId: string = null) {}
}

export class ResumeCallAction implements Action {
  readonly type = SabhaActionTypes.RESUME_ROOM_CALL;
  constructor(public roomId: string = null) {}
}

export class UpdateLocalMediaAction implements Action {
  readonly type = SabhaActionTypes.UPDATE_CALL_LOCAL_MEDIA;
  constructor(public callId: string, public joinWithVideo: boolean) {}
}

export class HangupCallAction implements Action {
  readonly type = SabhaActionTypes.HANGUP_ROOM_CALL;
  constructor(public roomId: string) {}
}

export class HangupCallSuccessAction implements Action {
  readonly type = SabhaActionTypes.HANGUP_CALL_SUCCESS;
  constructor() {}
}

export class HangupCallFailedAction implements Action {
  readonly type = SabhaActionTypes.HANGUP_CALL_FAILED;
  constructor(public error: any) {}
}

export class StartRoomCallSuccessAction implements Action {
  readonly type = SabhaActionTypes.START_ROOM_CALL_SUCCESS;
  constructor(public roomId: string) {}
}

export class StartRoomCallFailedAction implements Action {
  readonly type = SabhaActionTypes.START_ROOM_CALL_FAILED;
  constructor(public error: any, public roomId: string) {}
}

export class RemoveRoomAction implements Action {
  readonly type = SabhaActionTypes.REMOVE_ROOM;
  constructor(public roomId: string, public keepAlive: boolean = false) {}
}

export class RemoveRoomSuccessAction implements Action {
  readonly type = SabhaActionTypes.REMOVE_ROOM_SUCCESS;
  constructor(public roomId: string) {}
}

export class RemoveRoomFailedAction implements Action {
  readonly type = SabhaActionTypes.REMOVE_ROOM_FAILED;
  constructor(public error: any) {}
}

export class NavigateToIncidentAction implements Action {
  readonly type = SabhaActionTypes.NAVIGATE_TO_INCIDENT;
  constructor(public groupId: number, public mcDeviceId: string) {}
}

export class StartRcAction implements Action {
  readonly type = SabhaActionTypes.START_RC;
  constructor(public mcDeviceId: string) {}
}

export class RcStartedAction implements Action {
  readonly type = SabhaActionTypes.RC_STARTED;
  constructor(public mcDevice: IDeviceModel) {}
}

export class RcEndedAction implements Action {
  readonly type = SabhaActionTypes.RC_ENDED;
  constructor(public mcDeviceId: string) {}
}

export class SetMinifiedViewDevicedAction implements Action {
  readonly type = SabhaActionTypes.SET_MINIFIED_VIEW_DEVICE;
  constructor(public mcDevice: IDeviceModel) {}
}

export class RemoveMinifiedViewDeviceAction implements Action {
  readonly type = SabhaActionTypes.REMOVE_MINIFIED_VIEW_DEVICE;
  constructor() {}
}

export class OpenChatWindowAction implements Action {
  readonly type = SabhaActionTypes.OPEN_CHAT_WINDOW;
  constructor() {}
}

export class ResizeChatWindowAction implements Action {
  readonly type = SabhaActionTypes.RESIZE_CHAT_WINDOW;
  constructor(public dialogSize: DeviceChatDialogSize) {}
}

export class SetChatWindowSizeOnHideAction implements Action {
  readonly type = SabhaActionTypes.SET_CHAT_WINDOW_SIZE_ON_HIDE;
  constructor() {}
}

export class SelectCurrentViewAction implements Action {
  readonly type = SabhaActionTypes.SELECT_CURRENT_VIEW;
  constructor(public currentView: DeviceChatDialogView) {}
}

export class ChatConfigLoadSuccessAction implements Action {
  readonly type = SabhaActionTypes.CHAT_CONFIG_LOAD_SUCCESS;
  constructor(public chatConfig: IChatConfiguration) {}
}

export class UpdateChatWindowPositionAction implements Action {
  readonly type = SabhaActionTypes.UPDATE_CHAT_WINDOW_POSITION;
  constructor(public position: DeviceChatDialogPosition, public updateLocalStorage: boolean = true) {}
}

export class ShowChatErrorViewAction implements Action {
  readonly type = SabhaActionTypes.SHOW_CHAT_ERROR_VIEW;
  constructor(
    public errorType: ErrorViewType,
    public deviceId?: string,
    public technicianName?: string,
    public isVideoCallAllowed?: boolean,
    public roomId?: string
  ) {}
}

export class ShowChatPermissionErrorViewAction implements Action {
  readonly type = SabhaActionTypes.SHOW_CHAT_PERMISSION_ERROR_VIEW;
  constructor(public deviceId: string, public permission: string) {}
}
export class UpdateActiveCallRoomAction implements Action {
  readonly type = SabhaActionTypes.UPDATE_ACTIVE_CALL_ROOM;
  constructor(public roomId: string) {}
}

export class AddInactiveRoomAction implements Action {
  readonly type = SabhaActionTypes.ADD_INACTIVE_ROOM;
  constructor(public roomId: string, public expiresIn: number) {}
}

export class RemoveInactiveRoomAction implements Action {
  readonly type = SabhaActionTypes.REMOVE_INACTIVE_ROOM;
  constructor(public roomId: string) {}
}

export class UpdateRoomActivityAction implements Action {
  readonly type = SabhaActionTypes.UPDATE_ROOM_ACTIVITY;
  constructor(public roomId: string) {}
}

export class UpdateSabhaUserPreferenceAction implements Action {
  readonly type = SabhaActionTypes.UPDATE_SABHA_USER_PREFERENCE;
  constructor(public sabhaUserPreference: SabhaUserPreference) {}
}

export class UpdateSabhaUserPreferenceSuccessAction implements Action {
  readonly type = SabhaActionTypes.UPDATE_SABHA_USER_PREFERENCE_SUCCESS;
  constructor(public sabhaUserPreference: SabhaUserPreference) {}
}

export class SetSabhaUserPreferenceAction implements Action {
  readonly type = SabhaActionTypes.SET_SABHA_USER_PREFERENCE;
  constructor(public sabhaUserPreference: SabhaUserPreference) {}
}

export class SetDeviceSearchTextAction implements Action {
  readonly type = SabhaActionTypes.SET_DEVICE_SEARCH_TEXT;
  constructor(public deviceSearchText: string) {}
}

export class McConnectionsLoadSuccessAction implements Action {
  readonly type = SabhaActionTypes.MC_CONNECTIONS_LOAD_SUCCESS;
  constructor(public mcConnections: IMCConnectionInfo[]) {}
}

export class DownloadChatTranscriptAction implements Action {
  readonly type = SabhaActionTypes.DOWNLOAD_CHAT_TRANSCRIPT;
  constructor(public roomId: string) {}
}

export class SendChatMessageAction implements Action {
  readonly type = SabhaActionTypes.SEND_CHAT_MESSAGE;
  constructor(public roomId: string, public message: string) {}
}

export class ClearRoomNotificationsAction implements Action {
  readonly type = SabhaActionTypes.CLEAR_ROOM_NOTIFICATIONS;
  constructor(public roomId: string) {}
}

export class AddDialogAction implements Action {
  readonly type = SabhaActionTypes.ADD_DIALOG;
  constructor(public dialogId: string) {}
}

export class RemoveDialogAction implements Action {
  readonly type = SabhaActionTypes.REMOVE_DIALOG;
  constructor(public dialogId: string) {}
}

export class CloseDialogAction implements Action {
  readonly type = SabhaActionTypes.CLOSE_DIALOG;
  constructor(public dialogId: string) {}
}

export class CloseAllDialogsAction implements Action {
  readonly type = SabhaActionTypes.CLOSE_ALL_DIALOGS;
  constructor() {}
}

export class CloseAllDialogsSuccessAction implements Action {
  readonly type = SabhaActionTypes.CLOSE_ALL_DIALOGS_SUCCESS;
  constructor() {}
}

export class OpenDialogSuccessAction implements Action {
  readonly type = SabhaActionTypes.OPEN_DIALOG_SUCCESS;
  constructor(public dialogId: string, public afterClosed$: () => Observable<any>) {}
}

export type SabhaActions =
  | HttpErrorAction
  | InitAction
  | SignOutAction
  | LoadOnboardingSettingsSuccessAction
  | DisableOnboardingAction
  | SabhaUserLoadSuccessAction
  | SelectRoomAction
  | SetRoomStartTypeAction
  | AddPendingActiveChatAction
  | RemovePendingActiveChatAction
  | SabhaLocalPresenceStatusChangeAction
  | SabhaLocalPresenceStatusChangedAction
  | StartDeviceChatAction
  | StartDeviceChatSuccessAction
  | StartDeviceChatFailedAction
  | StartRoomCallAction
  | ValidateSupportBeforeCallRingAction
  | RingingCallAction
  | CleanupRingingCallAction
  | HoldCallAction
  | ResumeCallAction
  | HangupCallAction
  | HangupCallSuccessAction
  | HangupCallFailedAction
  | StartRoomCallSuccessAction
  | StartRoomCallFailedAction
  | RemoveRoomAction
  | RemoveRoomSuccessAction
  | RemoveRoomFailedAction
  | StartRcAction
  | RcStartedAction
  | SetMinifiedViewDevicedAction
  | RemoveMinifiedViewDeviceAction
  | RcEndedAction
  | NavigateToIncidentAction
  | OpenChatWindowAction
  | ResizeChatWindowAction
  | SelectCurrentViewAction
  | SabhaParticipantExistsErrorAction
  | ShowPermissionErrorNotificationAction
  | UpdateLocalMediaAction
  | ShowChatNotificationAction
  | ShowChatNotificationSuccessAction
  | HideChatNotificationAction
  | SetSabhaAllowedAction
  | ChatConfigLoadSuccessAction
  | UpdateChatWindowPositionAction
  | SabhaDeviceErrorAction
  | ShowChatErrorViewAction
  | UpdateActiveCallRoomAction
  | AddInactiveRoomAction
  | RemoveInactiveRoomAction
  | UpdateRoomActivityAction
  | UpdateSabhaUserPreferenceAction
  | UpdateSabhaUserPreferenceSuccessAction
  | SetSabhaUserPreferenceAction
  | SetDeviceSearchTextAction
  | ShowChatPermissionErrorViewAction
  | McConnectionsLoadSuccessAction
  | SetChatWindowSizeOnHideAction
  | SabhaInitStateChangedAction
  | SabhaRoomLoadingAction
  | DownloadChatTranscriptAction
  | SabhaCallTimeoutAction
  | ShowExistingCallPromptAction
  | SendChatMessageAction
  | ClearRoomNotificationsAction
  | AddDialogAction
  | RemoveDialogAction
  | CloseDialogAction
  | CloseAllDialogsAction
  | CloseAllDialogsSuccessAction
  | OpenDialogSuccessAction
  | ToggleChatAction;
